import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useProjectExternalResource,
  useFind: useProjectExternalResources,
  useCreate: useProjectExternalResourceCreation,
  useUpdate: useProjectExternalResourceUpdate,
  useDelete: useProjectExternalResourceDeletion,
} = getCRUDHooks({
  entityName: 'projectExternalResources',
  get: async ({ projectId, resourceId }) => {
    const { body } = await clientApi
      .getOCClient()
      .helpers.learningContent.projects.getExternalResources(projectId);

    return {
      body: body.find(({ id }) => id === resourceId) || null,
    };
  },
  find: ({ projectId }) =>
    clientApi.getOCClient().helpers.learningContent.projects.getExternalResources(projectId),
  create: (resource, { projectId }) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.projects.createExternalResource(projectId, resource),
  update: (newResource, { resourceId }) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.externalResources.partialUpdate(resourceId, newResource),
  remove: ({ projectId, resourceId }) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.projects.deleteExternalResource(projectId, resourceId),
});

const { useUpdate: useProjectExternalResourceOrder } = getCRUDHooks({
  entityName: 'projectExternalResourceOrder',
  sharedCacheEntities: ['projectExternalResources'],
  update: ({ newOrder, projectId }) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.projects.orderExternalResources(projectId, newOrder),
});

export {
  useProjectExternalResource,
  useProjectExternalResources,
  useProjectExternalResourceCreation,
  useProjectExternalResourceUpdate,
  useProjectExternalResourceDeletion,
  useProjectExternalResourceOrder,
};
